<template>
    <div class="subscriptions pb-10">
		<page-title title="Stream Stickers Premium"></page-title>

        <Header />
        <Plans />

    </div>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue';
import Header from './subscriptions/Header.vue';
import Plans from './subscriptions/Plans.vue';

export default {
    components: {
        PageTitle,
        Header,
        Plans
    }
}
</script>